"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Contact = _interopRequireDefault(require("./translations/Contact"));

var _Enterprise = _interopRequireDefault(require("./translations/Enterprise"));

var _General = _interopRequireDefault(require("./translations/General"));

var _Greetings = _interopRequireDefault(require("./translations/Greetings"));

var _Login = _interopRequireDefault(require("./translations/Login"));

var _User = _interopRequireDefault(require("./translations/User"));

var _Errors = _interopRequireDefault(require("./translations/Errors"));

var _Filter = _interopRequireDefault(require("./translations/Filter"));

var _Policy = _interopRequireDefault(require("./translations/Policy"));

var _SearchBar = _interopRequireDefault(require("./translations/SearchBar"));

var _MapData = _interopRequireDefault(require("./translations/MapData"));

var _OpeningHours = _interopRequireDefault(require("./translations/OpeningHours"));

var _Projects = _interopRequireDefault(require("./translations/Projects"));

var _Responses = _interopRequireDefault(require("./translations/Responses"));

var _SocialMedia = _interopRequireDefault(require("./translations/SocialMedia"));

var _WeCare = _interopRequireDefault(require("./translations/WeCare"));

var _CustomerInfo = _interopRequireDefault(require("./translations/CustomerInfo"));

var _Backoffice = _interopRequireDefault(require("./translations/Backoffice"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 2. Merge the translation files into one object
var translations = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  "default": {
    nl: "Geen vertaling gevonden",
    fr: "Il n'y a pas de traduction",
    en: "No translation found",
    de: "Keine Übersetzung gefunden"
  }
}, _Contact["default"]), _Enterprise["default"]), _Errors["default"]), _Filter["default"]), _General["default"]), _Greetings["default"]), _Login["default"]), _MapData["default"]), _OpeningHours["default"]), _Policy["default"]), _Projects["default"]), _Responses["default"]), _SearchBar["default"]), _SocialMedia["default"]), _User["default"]), _WeCare["default"]), _CustomerInfo["default"]), _Backoffice["default"]); // 3. User can now access his translation 
// by just giving key and language


var Translate = function Translate() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Add text to be translated";
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
  return translations[text] ? translations[text][lang] ? translations[text][lang] : text : text;
};

var _default = Translate;
exports["default"] = _default;